import React from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import { texts as stepOneTexts } from "../steps/stepOne";
import CarouselItem from "../../components/carouselItem";

import { makeStyles } from "@material-ui/core";
import Carousel from "react-material-ui-carousel";

const useStyles = makeStyles(
  () => ({
    carousel: {
      alignContent: "stretch",
      alignItems: "stretch",
      display: "flex",
      flexDirection: "column",
      height: "100%"
    },
    root: {
      height: "calc(100% - 77px)",
      padding: "10px",
      width: "100%"
    }
  }),
  { name: "MobileStepOne" }
);

const setTextOneCheckedCard = (card) => ({ type: "CHECK_CARD_STEP_ONE", payload: card });

export default function MobileStepOne() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const checkedCardStepOne = useSelector((state) => state.checkedCardStepOne);
  const mappedTexts = React.useMemo(() => _.map(stepOneTexts, (text) => ({ heading: text[0], text: text[1] })), []);

  const onTextCardClick = React.useCallback(
    (text) => {
      if (checkedCardStepOne !== text) {
        dispatch(setTextOneCheckedCard(text));
      }
    },
    [checkedCardStepOne, dispatch]
  );

  return (
    <div className={classes.root}>
      <Carousel
        autoPlay={false}
        animation={"slide"}
        fullHeightHover={false}
        className={classes.carousel}
        navButtonsAlwaysInvisible={true}
        indicatorIconButtonProps={{
          style: {
            color: "rgba(0, 0, 0, 0.54)"
          }
        }}
        activeIndicatorIconButtonProps={{
          style: {
            color: "#C51344"
          }
        }}
      >
        {mappedTexts.map((item, i) => (
          <CarouselItem key={i} item={item} onClick={onTextCardClick} />
        ))}
      </Carousel>
    </div>
  );
}
